import _ from 'lodash';

declare module 'lodash' {
    interface LoDashStatic {
        isNotEmpty: (value: unknown) => boolean;
        isNotNil: (value: unknown) => boolean;
        isNotInRange: (value: number, start: number, end: number) => boolean;
    }
}

const isNotEmpty = (value: unknown): boolean => {
    return !_.isNil(value) && !_.isEmpty(value);
};

const isNotNil = (value: unknown): boolean => {
    return !_.isNil(value);
};

const isNotInRange = (value: number, start: number, end: number): boolean => {
    return !_.inRange(value, start, end);
};

_.mixin({ isNotEmpty, isNotNil, isNotInRange });

export default _;
